<!-- Intro Header -->
<header class="sdg-status">
  <link rel="stylesheet" href="/src/assets/css/style.css">
  <link rel="stylesheet" href="/ko/src/assets/css/style.css">
  <div class="intro-body">
    <div class="container">
      <div class="col-md-12" appDynamicDirection>
        <div class="row">
          <div class="col-sm-6 title">
            <h4 class="page-heading" i18n>Water-Related Sustainable Development Goals</h4>
            <h2 class="intro-text" i18n>Finance - Reporting</h2>
          </div>
          <div class="col-sm-6">
            <!-- <a (click) = "financeBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
              <span i18n>Resources</span>
            </a> -->
            <a (click) = "quesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
              <span i18n>Questionnaire</span>
            </a>
            <!-- <a (click) = "dataBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
              <span i18n>Data</span>
            </a> -->
            <a (click) = "reportBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px; background: #1f487c;">
              <span i18n>Reporting</span>
            </a>

            <a (click) = "exportBtnClick()" class="btn btn-circle-sm text-center" style="margin-bottom: 15px;" [class.disabledanchor]="loading">
              <span i18n>Generate<br/>PDF</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>


<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas2" style="width: 1200px; height: 600px;" width="1200" height="600">{{ chart2 }}</canvas>
  </div>
</div>

<div class="chartWrapper  chart-cont">
  <div class="chartAreaWrapper">
    <canvas id="canvas1" style="width: 1200px; height: 600px;" width="1200" height="600">{{ chart1 }}</canvas>
  </div>
  <div class="chart-label">
    <ul>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="
    background:#239561; ">
    </div>
    <p>{{translation['Adequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #abd9d6;">
      </div>
  <p>{{translation['In development']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #cb331f;">
      </div>
    <p>{{translation['Inadequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="background:#3b3d3e;">
    </div>
    <p>{{translation['Unknown/No Data']}}
    </p>
    </div>
    </li>
    </ul>
    </div>
</div>


<div class="chartWrapper chart-cont">
  <div class="chartAreaWrapper">
    <canvas id="canvas5" style="width: 1200px; height: 600px;" width="1200" height="600">{{ chart5 }}</canvas>
  </div>
  <div class="chart-label">
    <ul>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="
    background:#239561; ">
    </div>
    <p>{{translation['Adequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #abd9d6;">
      </div>
  <p>{{translation['In development']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #cb331f;">
      </div>
    <p>{{translation['Inadequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="background:#3b3d3e;">
    </div>
    <p>{{translation['Unknown/No Data']}}
    </p>
    </div>
    </li>
    </ul>
    </div>

</div>


<div class="chartWrapper chart-cont">
  <div class="chartAreaWrapper">
    <canvas id="canvas3"  style="width: 1200px; height: 600px;" width="1200" height="600">{{ chart3 }}</canvas>
  </div>
  <div class="chart-label">
    <ul>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="
    background:#239561; ">
    </div>
    <p>{{translation['Adequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #abd9d6;">
      </div>
  <p>{{translation['In development']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #cb331f;">
      </div>
    <p>{{translation['Inadequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="background:#3b3d3e;">
    </div>
    <p>{{translation['Unknown/No Data']}}
    </p>
    </div>
    </li>
    </ul>
    </div>
</div>

<div class="chartWrapper chart-cont">
  <div class="chartAreaWrapper">
    <canvas id="canvas4" style="width: 1200px; height: 600px;" width="1200" height="600">{{ chart4 }}</canvas>
  </div>
  <div class="chart-label">
    <ul>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="
    background:#239561; ">
    </div>
    <p>{{translation['Adequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #abd9d6;">
      </div>
  <p>{{translation['In development']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #cb331f;">
      </div>
    <p>{{translation['Inadequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="background:#3b3d3e;">
    </div>
    <p>{{translation['Unknown/No Data']}}
    </p>
    </div>
    </li>
    </ul>
    </div>
</div>

<div class="chartWrapper chart-cont">
  <div class="chartAreaWrapper">
    <canvas id="canvas6" style="width: 1200px; height: 600px;" width="1200" height="600">{{ chart6 }}</canvas>
  </div>
  <div class="chart-label">
    <ul>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="
    background:#239561; ">
    </div>
    <p>{{translation['Adequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #abd9d6;">
      </div>
  <p>{{translation['In development']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
      <div class="chart-label-content-box" style="background: #cb331f;">
      </div>
    <p>{{translation['Inadequate']}}
    </p>
    </div>
    </li>
    <li>
    <div class="chart-label-content">
    <div class="chart-label-content-box" style="background:#3b3d3e;">
    </div>
    <p>{{translation['Unknown/No Data']}}
    </p>
    </div>
    </li>
    </ul>
    </div>
</div>







// WEBPACK FOOTER //
// ./src/app/sdg/finance-report/finance-report.component.html